import { Link } from "@remix-run/react";
import React from "react";
import className from "~/kernel/styling/className";
import Icon from "./Icon";
import List from "./List";

type LinkDef = {
  to: string;
  children: React.ReactNode;
  key?: string;
  active?: boolean;
  external?: boolean;
  target?: string;
};

type Props = {
  links: Array<LinkDef>;
  compact?: boolean;
};

export default function LinkList({ compact = false, links }: Props) {
  return (
    <List>
      {links.map((link) => {
        const classes = className(
          "flex flex-row items-center border-b gap-2 border-slate-200 last:border-b-0",
          { "py-5": !compact },
          { "px-2": compact },
          { "hover:underline": !link.active },
          { "bg-secondary hover:bg-sky-700": link.active },
        );
        const iconClassName = className({ "text-white": link.active });

        if (link.external) {
          return (
            <a
              className={classes}
              href={link.to}
              key={link.key ?? link.to}
              target={link.target}
            >
              <div className="flex-1">{link.children}</div>
              <Icon name="chevron-right" className={iconClassName} />
            </a>
          );
        }

        return (
          <Link
            className={classes}
            key={link.key ?? link.to}
            target={link.target}
            to={link.to}
          >
            <div className="flex-1">{link.children}</div>
            <Icon name="chevron-right" className={iconClassName} />
          </Link>
        );
      })}
    </List>
  );
}
